import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    header: {
        display: "flex",
        alignItems: "center",
        padding: "0px 22px",
        justifyContent: "space-between",
    },
    selectWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    label: {
        color: theme.palette.text.secondary,
        textAlign: "left",
    },
    select: {
        backgroundColor: theme.palette.secondary.main,
        width: "150px",
        height: "45px",
        borderRadius: "4px",
        boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
        marginBottom: "5px",
        fontFamily: "Source Sans 3 !important",
    },
    menuItem: {
        fontFamily: "Source Sans 3 !important",
    },
    dropdownBox: {
        display: "flex",
        gap: theme.spacing(4),
    },
    statusBox: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(4),
    },
}));
